import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getPumaObjectTypeUrl } from 'flow-doctor-lib/utils/urls';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import { getUrlForObjectTypeId } from 'flow-doctor-lib/utils/objectUtils';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { jsx as _jsx } from "react/jsx-runtime";
const WalmartFilterBranchAssociationLabel = ({
  objectTypeId,
  objectId,
  associationDisplayMode
}) => {
  const portalId = PortalIdParser.get();
  if (objectId && associationDisplayMode === 'OBJECT_ID') {
    const objectUrl = getUrlForObjectTypeId({
      objectId,
      objectTypeId,
      portalId: portalId
    });
    if (objectUrl) {
      return /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "flow-doctor-lib.filters.association.objectLabelWithObject_jsx",
          elements: {
            Link: UILink
          },
          options: {
            external: true,
            objectTypeLabel: /*#__PURE__*/_jsx(ObjectTypeLabel, {
              objectTypeId: objectTypeId,
              portalId: portalId
            }),
            href: objectUrl,
            children: /*#__PURE__*/_jsx(ObjectNameLabel, {
              objectId: objectId,
              objectTypeId: objectTypeId,
              portalId: portalId
            })
          }
        })
      });
    } else {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "flow-doctor-lib.filters.association.objectLabelWithoutUrl_jsx",
        elements: {
          b: 'b'
        },
        options: {
          objectTypeLabel: /*#__PURE__*/_jsx(ObjectTypeLabel, {
            objectTypeId: objectTypeId,
            portalId: portalId
          }),
          objectName: /*#__PURE__*/_jsx(ObjectNameLabel, {
            objectId: objectId,
            objectTypeId: objectTypeId,
            portalId: portalId
          })
        }
      });
    }
  }

  // Show link to object in PUMA if internal view
  if (getIsInternal()) {
    return /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "flow-doctor-lib.filters.association.objectLabel_jsx",
        elements: {
          Link: UILink
        },
        options: {
          external: true,
          objectTypeLabel: /*#__PURE__*/_jsx(ObjectTypeLabel, {
            objectTypeId: objectTypeId,
            portalId: portalId
          }),
          href: getPumaObjectTypeUrl({
            objectTypeId,
            portalId
          })
        }
      })
    });
  }
  return /*#__PURE__*/_jsx("b", {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "flow-doctor-lib.filters.association.objectLabel",
      options: {
        objectTypeLabel: /*#__PURE__*/_jsx(ObjectTypeLabel, {
          objectTypeId: objectTypeId,
          portalId: portalId
        })
      }
    })
  });
};
export default WalmartFilterBranchAssociationLabel;